import { render, staticRenderFns } from "./EodTabs.vue?vue&type=template&id=826ccde2&scoped=true&"
import script from "./EodTabs.vue?vue&type=script&lang=js&"
export * from "./EodTabs.vue?vue&type=script&lang=js&"
import style0 from "./EodTabs.vue?vue&type=style&index=0&id=826ccde2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826ccde2",
  null
  
)

export default component.exports